import { useEffect } from 'react'
import { track } from '../utils/track'

/** Fires a single ViewContent event once the reader passes 50% of the page. */
export function useViewContent(): void {
  useEffect(() => {
    let fired = false

    const onScroll = () => {
      if (fired) return
      const scrolled = window.scrollY + window.innerHeight
      const total = document.body.scrollHeight
      if (total > 0 && scrolled / total >= 0.5) {
        fired = true
        track('ViewContent')
        window.removeEventListener('scroll', onScroll)
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])
}
